import { createFileRoute } from "@tanstack/react-router";
import { InspectionRecordDetailPage } from "@/components/inventory/InspectionRecordDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/inspections_/$id")({
  component: InspectionRecordDetailRoute,
});

function InspectionRecordDetailRoute() {
  const { id } = Route.useParams();
  return <InspectionRecordDetailPage inspectionId={id} />;
}
